import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex space-x-3 items-center text-center mt-5"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col space-y-4"
}
const _hoisted_3 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfoComponent = _resolveComponent("UserInfoComponent")!
  const _component_StoryList = _resolveComponent("StoryList")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_StatusModal = _resolveComponent("StatusModal")!
  const _component_BalanceCard = _resolveComponent("BalanceCard")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_MainPageSkeleton = _resolveComponent("MainPageSkeleton")!
  const _component_PayCards = _resolveComponent("PayCards")!
  const _component_UserCards = _resolveComponent("UserCards")!
  const _component_NewCardIcon = _resolveComponent("NewCardIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PullRefresh = _resolveComponent("PullRefresh")!
  const _component_StandartTemplate = _resolveComponent("StandartTemplate")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createBlock(_component_StandartTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_UserInfoComponent, {
        onHandleClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setWithdrawInfoDrawerDescription('sand')))
      }),
      _createVNode(_component_StoryList),
      _createVNode(_component_ConfirmModal, {
        modelValue: _ctx.confirmModalDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmModalDialog) = $event)),
        "confirm-button-text": "Да",
        description: `Выплата начнется автоматически через ${_ctx.withdrawTime} секунд.\n Вы действительно хотите вывести сумму ${_ctx.withdrawBalance}\n ${_ctx.formTextWithdrawConfirm()}`,
        "decline-button-text": "Нет",
        onDecline: _ctx.clearWithdrawInterval,
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onConfirmWithdrawMoney()))
      }, null, 8, ["modelValue", "description", "onDecline"]),
      _createVNode(_component_ConfirmModal, {
        description: 'Списываем деньги с баланса Яндекс. Чтобы списание прошло без ошибок мы блокируем вывод на 15 минут. Нажмите ОК, чтобы перейти в раздел уведомлений и проверить статус перевода.',
        modelValue: _ctx.stateInfoWithdrawDialog,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.stateInfoWithdrawDialog) = $event)),
        "confirm-button-text": "ОК",
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/notifications')))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_ConfirmModal, {
        modelValue: _ctx.stateWithdrawParkInfoWa,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stateWithdrawParkInfoWa) = $event)),
        description: "Партнер не указал Whatsapp. Обратитесь к партнеру через Telegram или напрямую через Яндекс Про",
        "confirm-button-text": "Хорошо"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_ConfirmModal, {
        modelValue: _ctx.stateWithdrawParkInfoTm,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stateWithdrawParkInfoTm) = $event)),
        description: "Партнер не указал Telegram. Обратитесь к партнеру через Whatsapp или напрямую через Яндекс Про",
        "confirm-button-text": "Хорошо"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_ConfirmModal, {
        modelValue: _ctx.stateWithdrawInfoDrawer,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stateWithdrawInfoDrawer) = $event)),
        "html-description": _ctx.withdrawHtmlInfoDescription || '',
        description: _ctx.withdrawInfoDescription,
        "confirm-button-text": "Хорошо"
      }, null, 8, ["modelValue", "html-description", "description"]),
      _createVNode(_component_StatusModal, {
        type: "success",
        description: "Это свайпер, вам достаточно провести пальцем с право на лево и случится магия, попробуйте!",
        state: _ctx.infoSwiperModalDialog,
        "button-text": "Супер",
        onConfirm: _cache[8] || (_cache[8] = ($event: any) => {
        _ctx.infoSwiperModalDialog = false;
        _ctx.slideArrowBounce = false;
      })
      }, null, 8, ["state"]),
      _createVNode(_component_StatusModal, {
        cards: _ctx.payCardsData,
        cardIsActivate: this.cardIsActivate,
        type: "error",
        "html-description": _ctx.withdrawDialogDescription,
        state: _ctx.stateWithdrawDialog,
        "button-text": "Хорошо",
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateStateWithdrawDialog())),
        onConfirmCard: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmCard())),
        onOpenTelegram: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openTelegramSupport())),
        onDecline: _cache[12] || (_cache[12] = ($event: any) => (this.supportModal ? _ctx.openWa() : _ctx.openWhatsappSupport())),
        isWithdrawalConditions: _ctx.isWithdrawalConditions,
        onWithdrawalConditions: _ctx.checkWithdrawalConditions,
        isPaymentsOff: this.supportModal ? false : _ctx.activeCabinet?.is_payment,
        isActiveCard: this.supportModal ? 'support' : this.isActiveCard
      }, null, 8, ["cards", "cardIsActivate", "html-description", "state", "isWithdrawalConditions", "onWithdrawalConditions", "isPaymentsOff", "isActiveCard"]),
      _createVNode(_component_StatusModal, {
        type: "error",
        state: this.stateBlockedBalanceDialog,
        block_balance: this.activeCabinet?.block_balance,
        "button-text": "Хорошо",
        onConfirm: _cache[13] || (_cache[13] = ($event: any) => (this.stateBlockedBalanceDialog = false))
      }, null, 8, ["state", "block_balance"]),
      _createVNode(_component_PullRefresh, {
        modelValue: _ctx.reloadLoading,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.reloadLoading) = $event)),
        disabled: _ctx.isModalOpen,
        onRefresh: _ctx.onRefreshPage,
        "loading-text": "Обновляем информацию",
        "loosing-text": "Отпустите для обновления",
        "pulling-text": "Потяните для обновления",
        "success-text": "Успешно обновлено",
        "success-duration": "1500"
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            (_ctx.loading && _ctx.isHaveYandexCabinets && _ctx.isHaveCityCabinets)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-[35px] border border-[#A6B0CF] rounded-sm flex items-center justify-center transition-all", {
              'border-primary bg-primary': _ctx.cabinetsServiceView == 'Yandex',
            }]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => {
              _ctx.cabinetsServiceView = 'Yandex';
              _ctx.updateActiveSlideDetails();
            })
                  }, " Яндекс ", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-[35px] rounded-sm flex items-center justify-center transition-all border border-[#A6B0CF]", {
              'border-primary bg-primary': _ctx.cabinetsServiceView == 'CityMobil',
            }]),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => {
              _ctx.cabinetsServiceView = 'CityMobil';
              _ctx.updateActiveSlideDetails();
            })
                  }, " Сити ", 2)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              class: "my-4 text-xs text-[#EC655F] text-center cursor-pointer border border-[#EC655F] mx-auto px-4 py-2 rounded-lg underline underline-offset-4",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.setWithdrawInfoDrawerDescription && _ctx.setWithdrawInfoDrawerDescription(...args)))
            }, " Посмотреть условия вывода ", 512), [
              [_vShow, _ctx.loading && _ctx.activeCabinet]
            ]),
            _withDirectives(_createVNode(_component_Swiper, {
              "slides-per-view": 1,
              "css-mode": _ctx.validateCssMode(),
              class: _normalizeClass([{
            'padding-bottom-20-important': _ctx.allCabinets.length > 1,
            'padding-bottom-16-important': _ctx.allCabinets.length <= 1,
          }, "relative select-none mt-3 cursor-pointer"]),
              "simulate-touch": true,
              "space-between": 50,
              modules: [_ctx.pagination],
              pagination: { clickable: true },
              onSlideChange: _ctx.updateActiveSlideDetails,
              id: "swiper"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCabinetsDriverByService, (item, index) => {
                  return (_openBlock(), _createBlock(_component_SwiperSlide, {
                    key: index,
                    "data-cy": "swiperSlide",
                    "data-id": item.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BalanceCard, {
                        modelValue: item.balance,
                        "onUpdate:modelValue": ($event: any) => ((item.balance) = $event),
                        balance: item.balance as string,
                        subtitle: 'Несниж. остаток: ' + item.irreducible_balance,
                        title: item.name,
                        disabled: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "balance", "subtitle", "title"])
                    ]),
                    _: 2
                  }, 1032, ["data-id"]))
                }), 128)),
                (_ctx.slideArrowBounce && _ctx.filterCabinetsDriverByService.length > 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "animate-swipe absolute top-14 right-5 z-20 fill-blue",
                      onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.infoSwiperModalDialog = true), ["stop"]))
                    }, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("svg", {
                        width: "38",
                        height: "38",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", { d: "M3.5 4.02V2.75c0-.41-.34-.75-.75-.75S2 2.34 2 2.75V6c0 .55.45 1 1 1h3.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H4.09c2.11-1.86 4.88-3 7.91-3c4.42 0 7.27 2.19 8.25 4.1c.12.25.38.4.66.4c.56 0 .93-.59.67-1.08C20.3 3.39 16.81 1 12 1C8.78 1 5.82 2.13 3.5 4.02zm1.7 13.41c0-.65.6-1.13 1.24-.99l3.56.8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.38 1.21 1.22 1.09 2.07l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59l-4.07-4.29a.976.976 0 0 1-.28-.69z" })
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["css-mode", "class", "modules", "onSlideChange"]), [
              [_vShow, _ctx.loading]
            ]),
            (_ctx.loading && _ctx.activeCabinet)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (
              _ctx.activeCabinet.block_balance.block_balance ||
              _ctx.activeCabinet.block_balance?.error
            )
                    ? (_openBlock(), _createBlock(_component_BalanceCard, {
                        key: 0,
                        balance: _ctx.activeCabinet.block_balance?.block_balance || '',
                        block_balance: _ctx.activeCabinet.block_balance,
                        subtitle: "Подробнее",
                        title: _ctx.activeCabinet.block_balance?.error ? '' : ' Заблокировано',
                        isActiveCard: this.activeCabinet?.is_payment,
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (this.stateBlockedBalanceDialog = true))
                      }, null, 8, ["balance", "block_balance", "title", "isActiveCard"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BalanceCard, {
                    balance: _ctx.withdrawBalance,
                    comission: _ctx.commissionResult,
                    subtitle: 'Лимит: ' + _ctx.activeCabinet.limit_amount,
                    limit: _ctx.activeCabinet.limit_amount,
                    title: "Можно вывести",
                    max_amount: _ctx.activeCabinet.amount,
                    modelValue: _ctx.withdrawBalance,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.withdrawBalance) = $event)),
                    isActiveCard: this.activeCabinet?.is_payment,
                    onKeyup: _cache[20] || (_cache[20] = ($event: any) => (_ctx.removeLetterInWithdrawBalance('withdrawBalance')))
                  }, null, 8, ["balance", "comission", "subtitle", "limit", "max_amount", "modelValue", "isActiveCard"]),
                  _createVNode(_component_ButtonComponent, {
                    height: "10",
                    title: _ctx.makeActiveCard,
                    rounded: "lg",
                    class: "mt-3",
                    loading: _ctx.hasRequest,
                    onClickAction: _ctx.validateWithdrawMoney
                  }, null, 8, ["title", "loading", "onClickAction"])
                ]))
              : (_ctx.retryLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-center text-xl" }, " Не удалось запросить баланс с сервера. Нажмите на кнопку ниже чтобы запросить его ", -1)),
                    _createVNode(_component_ButtonComponent, {
                      height: "10",
                      title: "Запросить баланс",
                      rounded: "lg",
                      class: "mt-2",
                      loading: _ctx.hasRequest,
                      onClickAction: _cache[21] || (_cache[21] = ($event: any) => (_ctx.getCabinets(false)))
                    }, null, 8, ["loading"])
                  ]))
                : (_openBlock(), _createBlock(_component_MainPageSkeleton, { key: 3 }))
          ]),
          _withDirectives((_openBlock(), _createElementBlock("section", null, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mt-5 mb-4 text-grey" }, "Выберите карту для выплат", -1)),
            _createElementVNode("div", null, [
              (_ctx.payCardsData !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payCardsData, (item) => {
                        return (_openBlock(), _createBlock(_component_PayCards, {
                          key: item.id,
                          "card-id": item.id,
                          type: item.bank,
                          bank_name: item.bank_name,
                          bank: item.bank,
                          is_approved: item.is_approved,
                          title: item.name,
                          subtitle: _ctx.generateSubtitle(item),
                          "number-card": item.number,
                          "is-active": item.is_main,
                          class: "mb-2",
                          onClick: _withModifiers(($event: any) => (_ctx.setActiveCard(item.id)), ["stop"])
                        }, null, 8, ["card-id", "type", "bank_name", "bank", "is_approved", "title", "subtitle", "number-card", "is-active", "onClick"]))
                      }), 128))
                    ])), [
                      [_directive_auto_animate, { duration: 750 }]
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_UserCards, { key: 1 }))
            ]),
            _createVNode(_component_RouterLink, {
              to: "/new-card",
              class: "relative mt-3 flex h-28 items-center rounded-md bg-greyLight p-4 text-grey"
            }, {
              default: _withCtx(() => [
                _cache[25] || (_cache[25] = _createElementVNode("div", null, "Добавить карту", -1)),
                _createVNode(_component_NewCardIcon)
              ]),
              _: 1
            })
          ])), [
            [_directive_auto_animate]
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "onRefresh"])
    ]),
    _: 1
  }))
}